import { render, staticRenderFns } from "./DialogAddLecturesRegion.vue?vue&type=template&id=5e8eeda2"
import script from "./DialogAddLecturesRegion.vue?vue&type=script&lang=js"
export * from "./DialogAddLecturesRegion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e8eeda2')) {
      api.createRecord('5e8eeda2', component.options)
    } else {
      api.reload('5e8eeda2', component.options)
    }
    module.hot.accept("./DialogAddLecturesRegion.vue?vue&type=template&id=5e8eeda2", function () {
      api.rerender('5e8eeda2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLecturesRegion.vue"
export default component.exports